import React, { useState } from 'react'
import { Icon } from '@iconify/react'
import { ETitle } from '../../../../components/ui'
import { CloseButton } from '../../../../components/ui'
import { Modal } from '../../../../components/ui'

const OpenStack = ({ title, children, onClose }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleIconClick = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    if (onClose) onClose() // Gọi callback khi đóng modal
  }

  return (
    <div>
      <Icon
        icon="ph:stack"
        className="global-icon cursor-pointer text-[#0F5DB1]"
        onClick={handleIconClick}
      />
      {isModalOpen && (
        <Modal
          className="h-fit w-[70vw] rounded-lg bg-white p-8"
          onClose={handleCloseModal}
        >
          <header className="relative my-1 w-full">
            <ETitle text={title} className={'mb-8'} />
            <CloseButton
              className="absolute right-0 top-0"
              onClickHandler={handleCloseModal}
            />
          </header>
          <div>{children}</div>
        </Modal>
      )}
    </div>
  )
}

export default OpenStack
